import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ServiceManagerBase } from '../common/service-manager-base';
import { BroadcastService } from '../../core/services/broadcast.service';

import { UploadFileResult } from '../images/image-manager.service';
import { Folder } from './folder.model';
import { FolderApiService } from './folder-api.service';
import { PdfAsset } from '../pdfs/pdf-asset-model';
import { FolderEditModel } from './folder-edit.model';
import { OrganizationLinkEditModel } from '../link/organization-link-edit.model';
import { OrganizationLink } from '../link/organization-link.model';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FolderManagerService extends ServiceManagerBase
{
    constructor(private folderApiService: FolderApiService,
                protected override broadcastService: BroadcastService)
    {
        super(broadcastService);
    }

    clearCache()
    {
    }

    // Note: parentAlbumId = 0 for top-level
    getFolder(id: number): Observable<Folder>
    {
        return this.folderApiService.getFolder(id);
    }

    saveFolder(model: FolderEditModel): Observable<Folder>
    {
        if (model.Id === 0)
        {
            return this.folderApiService.createFolder(model);
        }

        return this.folderApiService.updateFolder(model);
    }

    addPdfToFolder(folderId: number, uploadResult: UploadFileResult): Observable<PdfAsset>
    {
        return this.folderApiService.addPdfToFolder(folderId, uploadResult);
    }

    deleteFolder(folderId: number): Observable<any>
    {
        return this.folderApiService.deleteFolder(folderId);
    }

    deleteItems(folderId: number, foldersToDelete: Folder[], pdfsToDelete: PdfAsset[]): Observable<Folder>
    {
        return this.folderApiService.deleteItems(folderId, foldersToDelete.map(f => f.Id), pdfsToDelete.map(p => p.Id));
    }

    moveItems(destinationFolder: Folder, foldersToMove: Folder[], pdfsToMove: PdfAsset[]): Observable<Folder>
    {
        return this.folderApiService.moveItems(destinationFolder.Id, foldersToMove.map(f => f.Id), pdfsToMove.map(p => p.Id));
    }
}
